import React from "react";
import { Body, BodyWithClass, CustomLink } from "@client/ui";

const Footer: React.FC = () => {
  return (
    <footer className={"bg-primary"} style={{ paddingTop: "20px" }}>
      <div className={`flex justify-center gap-[100px] text-white text-sm `}>
        <div>
          <BodyWithClass
            text="Our Services"
            className="font-primary font-bold text-[15px] mb-[30px]"
          />
          <div className="flex flex-col gap-2">
            <FooterItem title="Home Delivery" path="/home-delivery" />
            <FooterItem title="Tap-zus to Ride" path="/ride" />
            <FooterItem title="Own a Restaurant" path="/restaurant" />
          </div>
        </div>
        <div>
          <BodyWithClass text="Support" className="" />
          <div className="flex flex-col gap-2">
            <FooterItem title="Service 1" path="/service-1" />
            <FooterItem title="Service 2" path="/service-2" />
          </div>
        </div>
        <div>
          <BodyWithClass text="Contact" className="" />
        </div>
      </div>
      <p className="text-center text-background-light text-sm mt-4">
        &copy; {new Date().getFullYear()} Tapzus{" "}
      </p>
    </footer>
  );
};

export default Footer;

const FooterItem: React.FC<{ title: string; path: string }> = ({
  title,
  path,
}) => {
  return (
    <CustomLink
      to={path}
      text={title}
      tailwindcs="font-primary font-bold text-[20px] hover:text-blue-500"
    />
  );
};
